import { render, staticRenderFns } from "./TiktokOrderTables.vue?vue&type=template&id=77b1d5cc&"
import script from "./TiktokOrderTables.vue?vue&type=script&lang=js&"
export * from "./TiktokOrderTables.vue?vue&type=script&lang=js&"
import style0 from "./TiktokOrderTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports